export enum DialogType {
  AddAccounts,
  ManageLists,
  MoveList,
}
